import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <section className="privacy">
      <div className="privacy-container">
        <h1>Privacy Policy</h1>
        <p className="intro">
          At <strong>Cleanering</strong>, we respect your privacy and are committed
          to protecting your personal information. This Privacy Policy explains
          how we collect, use, and safeguard your data when you use our website
          or mobile application.
        </p>

        <h2>1. Information We Collect</h2>
        <p>
          We may collect personal information such as your name, email address,
          phone number, and service preferences when you sign up or submit
          forms. We also collect technical data like your IP address, device
          type, and browser for analytics and security.
        </p>

        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>To provide, operate, and improve our services.</li>
          <li>To process bookings, payments, and service updates.</li>
          <li>To send promotional or service-related communications.</li>
          <li>To ensure platform safety and prevent fraud.</li>
        </ul>

        <h2>3. Cookies and Tracking</h2>
        <p>
          We use cookies to personalize your experience, analyze traffic, and
          improve performance. You can control cookie preferences from your
          browser settings at any time.
        </p>

        <h2>4. Data Protection and Security</h2>
        <p>
          Your data is stored securely using encryption and restricted access.
          We do not sell or rent your personal information to third parties. All
          data transfers comply with global privacy standards (GDPR/CCPA).
        </p>

        <h2>5. Your Rights</h2>
        <p>
          You have the right to access, modify, or request deletion of your
          data. You may also opt-out of marketing communications by contacting
          our support team.
        </p>

        <h2>6. Account Deletion</h2>
        <p>
          To permanently delete your account, please visit our{" "}
          <a href="/delete-account">Account Delete Request</a> page and submit
          the form. Our team will process your request within 2 working days.
        </p>

        <h2>7. Updates to This Policy</h2>
        <p>
          Cleanering may update this policy from time to time. Any changes will
          be posted on this page with a new “Last Updated” date.
        </p>

        <h2>8. Contact Us</h2>
        <p>
          For any privacy concerns or questions, contact us at: <br />
          <strong>Email:</strong> support@cleanering.com <br />
          <strong>Phone:</strong> +91 98765 43210
        </p>

        <p className="last-updated">Last Updated: October 2025</p>
      </div>
    </section>
  );
};

export default PrivacyPolicy;